import React, { useState, useEffect } from 'react';
import { FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';

enum Status {
	saving = 'saving',
	saved = 'saved',
	failed = 'failed',
}

export interface ProductSaveIndicatorProps {
	hideAfterMilliseconds: number;
	status: Status | null;
}
export function ProductSaveIndicator({ hideAfterMilliseconds, status }: ProductSaveIndicatorProps) {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		if (status == Status.saving) {
			setVisible(true);
			return;
		}

		if (status == Status.saved) {
			setVisible(true);
			const timeoutId = setTimeout(() => {
				setVisible(false);
			}, hideAfterMilliseconds);

			return () => clearTimeout(timeoutId);
		}
	}, [status]);

	return (
		<div
			data-testid='save-indicator'
			className={`fixed left-0 bottom-4 w-full flex items-center justify-center text-center z-50 pointer-events-none transition duration-150 ease-in-out ${
				visible ? 'opacity-100' : 'opacity-0'
			}`}
		>
			<div
				className={`inline-flex items-center justify-center pl-1.5 pr-3 py-1 ring-2 rounded-full font-semibold text-[12px] tracking-wider pointer-events-auto transition ease-in-out ${
					status === Status.saving && 'ring-gray-100 text-green-500 bg-white'
				}
					${status === Status.saved && 'ring-green-100 text-white bg-green-500'} ${
					status === Status.failed && 'ring-red-100 text-white bg-red-500'
				}`}
			>
				{status == Status.saving && (
					<>
						<svg
							className='ml-px mr-1.5 h-4 w-4 animate-spin'
							xmlns='http://www.w3.org/2000/svg'
							fill='none'
							viewBox='0 0 24 24'
						>
							<circle className='opacity-10' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4'></circle>
							<path
								className='opacity-100'
								fill='currentColor'
								d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
							></path>
						</svg>{' '}
						Saving…
					</>
				)}
				{status == Status.saved && (
					<>
						<FaCheckCircle className='ml-px mr-1.5 w-4 h-4' />
						Saved!
					</>
				)}
				{status == Status.failed && (
					<>
						<FaExclamationTriangle className='relative -top-px ml-px mr-1.5 w-4 h-4' />
						Failed
					</>
				)}
			</div>
		</div>
	);
}
